import type { ComponentType } from 'react';

import {
  FUNNEL_QUESTION_SEGMENT,
  FUNNEL_SCREEN_SEGMENTS,
  NEW_FUNNEL_BASE_PATH,
} from '@/features/w2w/funnel/utils/funnel-paths';

const basePath = NEW_FUNNEL_BASE_PATH;

const pageTitle = 'Social Media Finder';

const handle = { pageTitle };

const loadLanding = async (): Promise<{ Component: ComponentType }> => {
  const { NewFunnelLandingRoute } = await import('./LandingRoute/LandingRoute');
  return { Component: NewFunnelLandingRoute };
};

const loadQuestion = async (): Promise<{ Component: ComponentType }> => {
  const { NewFunnelQuestionRoute } =
    await import('./QuestionRoute/QuestionRoute');
  return { Component: NewFunnelQuestionRoute };
};

const loadSearchProgress = async (): Promise<{ Component: ComponentType }> => {
  const { NewFunnelSearchProgressRoute } =
    await import('./SearchProgressRoute/SearchProgressRoute');
  return { Component: NewFunnelSearchProgressRoute };
};

const loadRegister = async (): Promise<{ Component: ComponentType }> => {
  const { NewFunnelRegisterRoute } =
    await import('./RegisterRoute/RegisterRoute');
  return { Component: NewFunnelRegisterRoute };
};

export const newFunnelRoutes = [
  { handle, path: basePath, lazy: loadLanding },
  {
    handle,
    path: `${basePath}/${FUNNEL_QUESTION_SEGMENT}/:questionKey`,
    lazy: loadQuestion,
  },
  {
    handle,
    path: `${basePath}/${FUNNEL_SCREEN_SEGMENTS.progress}`,
    lazy: loadSearchProgress,
  },
  {
    handle,
    path: `${basePath}/${FUNNEL_SCREEN_SEGMENTS.register}`,
    lazy: loadRegister,
  },
];

export const protectedNewFunnelRoutes = [
  {
    handle,
    path: `${basePath}/${FUNNEL_SCREEN_SEGMENTS.plan}`,
    lazy: async () => {
      const { NewFunnelPlanRoute } = await import('./PlanRoute/PlanRoute');
      return { Component: NewFunnelPlanRoute };
    },
  },
];
